import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PromocodeForm } from "../PromocodeForm";
import { CreatePromocodeModalProps } from "./types";
import { useCreatePromocodeModal } from "./controller";

export const CreatePromocodeModal = React.memo(({ modalRef, onComplete }: CreatePromocodeModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreatePromocodeModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("promocode_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <PromocodeForm />
    </Modal>
  );
});
